<template>
    <section class="section">
        <router-view
                v-if="sessid"
                :key="$route.name"
                :sessid="sessid"
                :isMobile="isMobile"
        />
    </section>
</template>

<script>
import BaseApp from '../BxBaseApp';

export default {
    name: "OrderPage",
    mixins: [BaseApp],
    data() {
        return {
            isMobile: false,
            sessid: null
        }
    },
    mounted() {
        this.initData()
    }
}
</script>

<style lang="scss">
@import "../../../../design_kit/site/blocks/cart/style.css";
@import "../../../../design_kit/site/blocks/popup/style.scss";
@import "../../../../design_kit/site/blocks/chbox/style.scss";
@import "../../../../design_kit/site/blocks/input/style.scss";
@import "../../../../design_kit/site/blocks/button/style.scss";
@import "../../../../design_kit/site/blocks/grid/style.scss";
</style>